/* eslint-disable react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import { PortalSellingPointsDataPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalInstitutionSellingPoints.scss';

export const PortalInstitutionSellingPoints = function (props) {
  const { anchor, title, sellingPoints } = props;

  return (
    <portal-institution-selling-points id={anchor}>
      <div className="row portal-section selling-points">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <h2>{title}</h2>
          {sellingPoints.map((sellingPoint, i) => (
            <div className="selling-point" key={i}>
              <div className="selling-point-image">
                <ResponsiveImage
                  src={sellingPoint.get('imageUrl')}
                  responsive
                  onResize="up"
                  resizeWidthOnly
                />
              </div>
              <div className="selling-point-text">
                <div className="title">{sellingPoint.get('title')}</div>
                <h5 className="blurb">{sellingPoint.get('content')}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </portal-institution-selling-points>
  );
};

PortalInstitutionSellingPoints.displayName = 'PortalInstitutionSellingPoints';
PortalInstitutionSellingPoints.propTypes = {
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sellingPoints: PortalSellingPointsDataPropType.isRequired,
};
